document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.anchor-bar')) {
    let items = [...document.querySelectorAll('[data-wf-nav-title]')]
      .filter((section) => section.getAttribute('data-wf-nav-title').trim() !== '')
      .map((section) =>
      `<li class="links-bar-item">
        <a class="links-bar-link" href="#${section.getAttribute('id')}" data-text="${section.getAttribute('data-wf-nav-title')}">${section.getAttribute('data-wf-nav-title')}</a>
      </li>`
    );
    document.querySelectorAll('.anchor-bar .links-bar').forEach((bar) => {
      bar.innerHTML = items.join('');
    })
  }
})
